define('common/linkUrlTokenReplacer',[
],
    function () {

        // This is a module for front-end replacing various tokens in links' (<a> tags) URLs.
        // For a start it only replaces {current_page_url} token with the current page's URL.
        // Its first use is in Links Menu component for putting the current page's URL into Login link.

        function replaceTokens(selector) {
            $(selector + " a").each(function (index, element) {
                // replacing current page url
                var token = "{current_page_url}";
                if (element.href.indexOf(token) >= 0) {
                    element.href = element.href.replace(token, location.href);
                }
            });
        }

        return {
            replaceTokens: replaceTokens
        };
    }
);

